import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ticket-wrapper" }
const _hoisted_2 = { class: "ticket-list flex-col" }
const _hoisted_3 = { class: "ticket-logo flex-row flex-align-start" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ticket-rates" }
const _hoisted_6 = { class: "qr-wrapper flex-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "flex-col disclaimer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (a, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "activity-ticket flex-col flex-align-center"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.ticketLogo,
              class: "ticket-logo"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("h2", null, _toDisplayString(a.name), 1),
          _createElementVNode("h3", null, _toDisplayString(a.date.day) + " " + _toDisplayString(a.date.time), 1),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.rates, (r, j) => {
              return (_openBlock(), _createElementBlock("li", { key: j }, _toDisplayString(r), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: `${_ctx.ticketQrCode}`,
              height: "250",
              width: "250"
            }, null, 8, _hoisted_7)
          ]),
          (a.disclaimer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "Ticket Disclaimer", -1)),
                _createElementVNode("p", null, _toDisplayString(a.disclaimer), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}